<template>
  <v-container fluid grid-list-md>
    <AppTitleBar>
      <template v-slot:title>{{ $t('labels.clients') }}</template>
      <template slot="actions">
        <v-tooltip top transition="fade-transition">
          <template v-slot:activator="{ on }">
            <v-btn icon small @click="create" v-on="on">
              <v-icon small v-text="$vuetify.icons.values.add" />
            </v-btn>
          </template>
          <span>{{ $t('newClient') }}</span>
        </v-tooltip>
      </template>
    </AppTitleBar>
    <v-row no-gutters justify="end">
      <v-col cols="12" sm="6" md="4" lg="3">
        <SingleSearchFilter :context="context" :fields="searchFields" />
      </v-col>
    </v-row>

    <v-card flat class="main-card">
      <v-card-text class="py-1 px-0">
        <v-data-table
          :headers="headers"
          :items="clients"
          item-key="name"
          :loading="loading"
          :page.sync="page"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          must-sort
          :items-per-page.sync="itemsPerPage"
          :footer-props="{ itemsPerPageOptions: itemsPerPageArray }"
          :server-items-length="tableItemsCount"
          class="main-table elevation-0"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn icon :to="viewItem(item)">
              <v-icon>{{ $vuetify.icons.values.view }}</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <router-view></router-view>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { AppTitleBar, SingleSearchFilter } from '@argon/app/components'
import { NAMESPACE } from '../store'
import { Datatable } from '@argon/app/mixins'
import clientPerimeter from '../perimeters.js'

export default {
  components: {
    AppTitleBar,
    SingleSearchFilter
  },
  perimeters: [clientPerimeter],
  mixins: [Datatable],
  data() {
    return {
      newDialog: false,
      headers: [
        { text: this.$t('labels.displayName'), value: 'display', align: 'left' },
        { text: '', value: 'actions', sortable: false, align: 'right' }
      ],
      searchFields: [{ label: 'display', type: 'text' }],
      loading: true,
      context: NAMESPACE
    }
  },
  computed: {
    ...mapState(NAMESPACE, ['clients', 'tableItemsCount'])
  },
  methods: {
    ...mapActions(NAMESPACE, ['listClients', 'clearClients']),
    viewItem(item) {
      return {
        name: 'clientPage',
        params: { ...this.$route.params, clientId: item.id }
      }
    },
    create() {
      this.$router.push({ name: 'newClient', params: { clientId: 'new' } })
    },
    fetchData() {
      return new Promise((resolve, reject) => {
        this.listClients({ pager: this.pager })
          .then(resolve)
          .catch(reject)
          .finally(() => {
            this.loading = false
          })
      })
    }
  },

  destroyed() {
    this.clearClients().catch(() => {})
  },
  created() {
    if (this.$client.isNotAllowed('atLeastAdvisor')) {
      return this.$router.push({ name: 'me' })
    }
    this.fetchData()
  },
  beforeRouteUpdate(to, from, next) {
    this.fetchData()
    next()
  }
}
</script>

<i18n>
{
  "en": {
    "newClient": "New Client"
  },
  "fr": {
    "newClient": "Nouveau client"
  }
}

</i18n>
